/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { Flex, Button } from "@chakra-ui/react";
import { makePayload } from "../utils";
import { ServicePointDetails } from "../../../components/servicePoints/service-point-details";

export default function Summary({
  servicePoint,
  onAddServicePoint,
  editing,
  onPrevStep,
}) {
  const [payload, setPayload] = useState(null);
  useEffect(() => {
    setPayload(createPayload(servicePoint));
  }, []);
  const createPayload = (data) => {
    const _servicePoint = { ...makePayload(servicePoint) };
    if (editing) {
      _servicePoint.id = data?.id || "";
    }
    return _servicePoint;
  };

  return (
    <>
      {payload ? <ServicePointDetails servicePoint={payload} /> : <></>}
      <Flex
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-end",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        <Button onClick={onPrevStep}>Back</Button>
        <Button
          onClick={() => {
            onAddServicePoint(payload);
          }}
        >
          {editing ? "Update Service Point" : "Create Service Point"}
        </Button>
      </Flex>
    </>
  );
}
